
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"23","viewBox":"0 0 35 23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.23 23c-1.44 0-5.82 0-17.56-17.01C-.53 4.24-.07 1.86 1.7.66 3.48-.53 5.9-.08 7.1 1.67c4.02 5.82 8.81 11.54 11.07 13.29 2.07-1.79 6.21-7.41 9.58-13.07C28.83.06 31.22-.55 33.07.52c1.85 1.07 2.48 3.42 1.39 5.24C24.23 23 19.72 23 18.23 23z"}})])
          )
        }
      }
    